<div class="col px-5 pt-3">
    <div class="role-main-tabs d-flex">
        <div class="role-tab disabled foreground">
            <span class="highlight">{{"Copy Value From form field to form field" | translate}}</span>
        </div>
    </div>
    <div class="mapping-container p-1 row align-items-stretch">
        <div class="mapping-left col-5 p-0 bg-white scrolled-region" (scroll)="handleScroll()">
            <generic-sfl [serviceId]="serviceId" [prefix]="'from'" [gatherLinks]="true" (cvfs)="getRelations($event);" (isReady)="ready('from')" (handleScroll)="handleScroll()"></generic-sfl>
        </div>
        <div class="mapping-center col-2 p-0"></div>
        <div class="mapping-right col-5 p-0 bg-white scrolled-region" (scroll)="handleScroll()">
            <generic-sfl [serviceId]="serviceId" [prefix]="'to'" (isReady)="ready('to')" (handleScroll)="handleScroll()"></generic-sfl>
        </div>
    </div>
</div>